import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, POST } from '../../Services/AxiosService';
import { CustomStringify } from "../../Helpers/CustomStringify";

export const fetchListAC = createAsyncThunk(
  "AccountNameList/fetchListAC",
  async (cmpdetail, { rejectWithValue }) => {
    try {
      const result = await GET(`/sellers/${cmpdetail?.key}`);
      return result?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.message)
    }
  }
);

const AccountNameListSlice = createSlice({
  name: "AccountNameList",
  initialState: {
    result: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchListAC.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchListAC.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.result = action.payload;
      })
      .addCase(fetchListAC.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default AccountNameListSlice.reducer;
